import { useParams } from 'react-router-dom';
import { useBookings } from '../../shared/booking/BookingsContext';
import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { busRefund, cancellationLines } from './data';
import BusSummary from './BusSummary';
import BusTrip from './BusTrip';

export default function BusBookingDetails() {
  const { bookingId } = useParams();
  const { getBooking } = useBookings();
  const booking = getBooking(bookingId);
  // Live tickets are cancelled with the operator from the ticket panel.
  const live = Boolean(booking?.supplierBookingId);

  return (
    <BookingDetailsPage
      module="bus"
      Summary={BusSummary}
      refLabel="Operator PNR"
      refund={busRefund}
      allowCancel={!live}
      extraDetails={live && <BusTrip booking={booking} allowCancel={booking.status !== 'cancelled'} />}
      policy={[
        ...cancellationLines(booking?.summary?.cancellation),
        'Refunds go to your original payment method within 5–7 working days; the convenience fee is not refunded.',
        'No refund if you miss the bus.',
      ]}
    />
  );
}
